/**
 * Czas na pasku i w etykietach „kontynuuj od…".
 *
 * Godziny pokazujemy tylko wtedy, gdy są — „0:12:34" przy dwunastu minutach
 * czyta się gorzej niż „12:34", a filmy pełnometrażowe i tak przekraczają
 * godzinę i wtedy trzy pola są konieczne.
 */
export function formatClock(seconds: number): string {
  const total = Math.max(0, Math.round(seconds));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  return h > 0
    ? `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
    : `${m}:${String(s).padStart(2, '0')}`;
}

/**
 * Prędkość transferu.
 *
 * Megabity, nie mebibajty na sekundę: tak podaje je operator łącza i tak brzmią
 * pomiary w `docs/ACQUISITION-MATRIX.md`, więc liczba na ekranie da się porównać
 * z tą z macierzy bez przeliczania. Poniżej megabita schodzimy na KiB/s, bo
 * „0,3 Mb/s” wygląda jak błąd zaokrąglenia, a „38 KiB/s” jak wolne pobieranie.
 */
export function formatSpeed(bytesPerSecond: number): string {
  const mbps = (bytesPerSecond * 8) / 1_000_000;
  if (mbps >= 1) return `${mbps.toFixed(1)} Mb/s`;
  return `${(bytesPerSecond / 1024).toFixed(0)} KiB/s`;
}

/**
 * Pozostały czas w postaci, która nie udaje precyzji.
 *
 * Sekundy tylko poniżej minuty: przy pięciu minutach „312 s” wymaga liczenia
 * w pamięci, a i tak jest oszacowaniem, które zmieni się za chwilę.
 */
export function formatDuration(seconds: number): string {
  if (seconds < 60) return `${Math.round(seconds)} s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min`;
  return `${Math.floor(minutes / 60)} h ${minutes % 60} min`;
}
